import { z } from "zod";
import { telemetryDataPointTypeSchema } from "../_shared";

export const storeUnprocessedFileSDataPointsPayloadSchema = z.object({
  type: telemetryDataPointTypeSchema,
  limit: z.number().min(1).optional(),
});

export type StoreUnprocessedFileSDataPointsPayload = z.infer<
  typeof storeUnprocessedFileSDataPointsPayloadSchema
>;
